/**
 * KYC/KYB-specific constants and settings
 */

export const KYC_STATUS_NONE = 0;
export const KYC_STATUS_UPGRADE_REQUEST = -3; // Voluntary completion of a full KYC check (from express KYC)
export const KYC_STATUS_STARTED = -1;
export const KYC_STATUS_UPGRADE_STARTED = -2;
export const KYC_STATUS_REJECTED = 1;
export const KYC_STATUS_SUBMITTED = 2;
export const KYC_STATUS_SOFT_REJECTED = 3;
export const KYC_STATUS_REVIEW_PENDING = 5;
export const KYC_STATUS_RESTRICTED_STARTED = 6;
export const KYC_STATUS_RESTRICTED_APPROVED = 8;
export const KYC_STATUS_EXPRESS_APPROVED = 9;
export const KYC_STATUS_OK = 10;

export const ONBOARDING_SUGGESTION_NONE = 0;
export const ONBOARDING_SUGGESTION_ADD_BANK = 1;
